import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useGoogleLogin } from "@react-oauth/google";
import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { djRestAuth } from "../api/api";
import { GoogleButton } from "../GoogleButton";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { AuthTermsNotice } from "./AuthTermsNotice";
import { UserContext } from "./UserProvider";
const Login = () => {
    const { setUser, setLoading: setUserLoading } = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from || "/";
    const login = useGoogleLogin({
        onSuccess: (tokenResponse) => {
            setLoading(true);
            djRestAuth
                .post("/google/", {
                accessToken: tokenResponse.access_token,
            })
                .then((response) => {
                const { data: { user }, } = response;
                setLoading(false);
                setUser(user);
                setUserLoading(false);
                navigate(from);
            })
                .catch(() => {
                setLoading(false);
                setError("Login failed. Please try again.");
            });
        },
    });
    const handleCloseSnackbar = () => {
        setError(null);
    };
    return (_jsx(Container, { component: "main", maxWidth: "xs", children: _jsxs(Box, { sx: {
                mt: { xs: 6, sm: 10 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }, children: [loading ? (_jsx(CircularProgress, { role: "progressbar" })) : (_jsxs(React.Fragment, { children: [_jsx(SportsSoccerIcon, { sx: { fontSize: 48, color: "primary.main", mb: 2 } }), _jsx(Typography, { role: "heading", component: "h1", variant: "h4", sx: { fontWeight: 700, mb: 1 }, children: "Log in to Log.Soccer" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 4, textAlign: "center" }, children: "Pick up where you left off." }), _jsx(GoogleButton, { onClick: () => login(), text: "Log in with Google" }), _jsx(AuthTermsNotice, {})] })), _jsx(ErrorSnackbar, { open: !!error, onClose: handleCloseSnackbar, message: error || "" })] }) }));
};
export default Login;
